module.exports = __webpack_public_path__ + "static/media/react.07923a4b.svg";